/* Outback header, menu drawer, search, cart drawer and cart page updates. No dependencies. */
(function(){
  'use strict';
  var d=document, html=d.documentElement;
  function $(s,r){return (r||d).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s));}
  var FOCUSABLE='a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var openDlg=null, lastFocus=null;

  function setExpanded(id,on){$$('[aria-controls="'+id+'"]').forEach(function(b){b.setAttribute('aria-expanded',on?'true':'false');});}
  function visible(el){return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length);}
  function openDialog(el,opener,focusEl){
    if(!el)return;
    if(openDlg&&openDlg!==el)closeDialog(openDlg,true);
    lastFocus=opener||d.activeElement;
    el.hidden=false;
    requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.add('is-open');});});
    html.classList.add('ob-lock');
    openDlg=el; setExpanded(el.id,true);
    setTimeout(function(){var f=focusEl||$('.obd-head [data-obd-close]',el)||$(FOCUSABLE,$('.obd-panel',el)); if(f)f.focus();},60);
  }
  function closeDialog(el,silent){
    if(!el)return;
    el.classList.remove('is-open'); setExpanded(el.id,false);
    if(openDlg===el)openDlg=null;
    html.classList.remove('ob-lock');
    setTimeout(function(){if(!el.classList.contains('is-open'))el.hidden=true;},300);
    if(!silent&&lastFocus&&lastFocus.focus){try{lastFocus.focus();}catch(e){}}
  }
  d.addEventListener('keydown',function(e){
    if(!openDlg)return;
    if(e.key==='Escape'){closeDialog(openDlg);return;}
    if(e.key==='Tab'){
      var f=$$(FOCUSABLE,$('.obd-panel',openDlg)).filter(visible);
      if(!f.length)return;
      var a=f[0], z=f[f.length-1];
      if(e.shiftKey&&(d.activeElement===a||!openDlg.contains(d.activeElement))){e.preventDefault();z.focus();}
      else if(!e.shiftKey&&(d.activeElement===z||!openDlg.contains(d.activeElement))){e.preventDefault();a.focus();}
    }
  });
  d.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('[data-obd-close]'); if(t){var dl=t.closest('.obd'); if(dl){e.preventDefault();closeDialog(dl);}}});

  /* Sticky shadow */
  var hdr=$('#ob-header');
  if(hdr&&'IntersectionObserver' in window){
    var s=d.createElement('div'); s.style.cssText='position:absolute;height:1px;width:1px;margin-top:-1px'; hdr.parentNode.insertBefore(s,hdr);
    new IntersectionObserver(function(en){hdr.classList.toggle('is-stuck',!en[0].isIntersecting);}).observe(s);
  }

  /* Mobile menu */
  var menu=$('#obh-menu');
  $$('[data-obh-menu-open]').forEach(function(b){b.addEventListener('click',function(){openDialog(menu,b);});});
  $$('.obm-acc').forEach(function(b){b.addEventListener('click',function(){var sub=d.getElementById(b.getAttribute('aria-controls')); var on=b.getAttribute('aria-expanded')!=='true'; b.setAttribute('aria-expanded',on?'true':'false'); if(sub)sub.hidden=!on;});});
  if(window.matchMedia){var mq=window.matchMedia('(min-width: 990px)'); var mqf=function(){if(mq.matches&&openDlg===menu)closeDialog(menu,true);}; if(mq.addEventListener)mq.addEventListener('change',mqf);}

  /* Desktop dropdowns (click, hover, keyboard) */
  $$('.obh-dd').forEach(function(li){
    var b=$('button',li), p=$('.obh-ddp',li), tm;
    function set(on){b.setAttribute('aria-expanded',on?'true':'false'); p.hidden=!on; li.classList.toggle('is-open',on);}
    var hover=window.matchMedia&&window.matchMedia('(hover: hover)').matches;
    b.addEventListener('click',function(){set(b.getAttribute('aria-expanded')!=='true');});
    if(hover){li.addEventListener('mouseenter',function(){clearTimeout(tm);set(true);}); li.addEventListener('mouseleave',function(){tm=setTimeout(function(){set(false);},180);});}
    li.addEventListener('keydown',function(e){if(e.key==='Escape'&&b.getAttribute('aria-expanded')==='true'){set(false);b.focus();}});
    li.addEventListener('focusout',function(e){if(e.relatedTarget&&!li.contains(e.relatedTarget))set(false);});
    d.addEventListener('click',function(e){if(!li.contains(e.target))set(false);});
  });

  /* Search panel */
  var sp=$('#obh-search'), sq=$('#obh-q'), st=$('[data-obh-search-toggle]');
  function search(on,back){if(!sp)return; sp.hidden=!on; setExpanded('obh-search',on); if(on){sq&&sq.focus();} else if(back&&st){st.focus();}}
  if(st)st.addEventListener('click',function(){search(sp.hidden);});
  $$('[data-obh-search-close]').forEach(function(b){b.addEventListener('click',function(){search(false,true);});});
  if(sp)sp.addEventListener('keydown',function(e){if(e.key==='Escape')search(false,true);});

  /* Cart */
  var cartDlg=$('[data-ob-cart-drawer]'), live=$('[data-ob-cart-live]');
  function onCartPage(){return /^\/cart\/?$/.test(location.pathname);}
  function sectionIds(){var ids=[]; if(cartDlg)ids.push('ob-cart-drawer'); if($('[data-ob-cart-page]'))ids.push('ob-cart-page'); return ids;}
  function money(c){return '$'+(c/100).toFixed(2);}
  function setCount(n){
    $$('[data-ob-cart-count]').forEach(function(el){el.textContent=n; el.hidden=n<1;});
    $$('[data-ob-cart-open]').forEach(function(a){a.setAttribute('aria-label','Cart, '+n+(n===1?' item':' items'));});
    $$('[data-ob-cart-n]').forEach(function(el){el.textContent='('+n+')';});
  }
  function apply(sections){
    Object.keys(sections||{}).forEach(function(id){
      var h=sections[id]; if(!h)return;
      var tmp=d.createElement('div'); tmp.innerHTML=h;
      var nb=$('[data-ob-cart-body]',tmp);
      var host=id==='ob-cart-drawer'?cartDlg:$('[data-ob-cart-page]');
      var ob=host&&$('[data-ob-cart-body]',host);
      if(nb&&ob)ob.innerHTML=nb.innerHTML;
    });
  }
  function refresh(){
    var ids=sectionIds();
    if(ids.length)fetch('/?sections='+ids.join(','),{credentials:'same-origin'}).then(function(r){return r.json();}).then(apply).catch(function(){});
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count); giftSync();}).catch(function(){});
  }

  /* Free Magnesium+ gift at $60: assets/ob-gift.js (loaded before this file) keeps the $0 gift line in sync on every
     cart call. Here we only ask it to check on drawer open / cart page load, and re-render when it changed the cart. */
  function giftSync(){if(window.OBGift)window.OBGift.sync();}
  d.addEventListener('ob:gift',function(e){
    if(live&&e.detail==='added')live.textContent='A free bottle of Magnesium+ was added to your cart.';
    setTimeout(refresh,60);
  });
  function giftChoice(b,attr,key){
    var body=b.closest('[data-ob-cart-body]');
    if(body){body.classList.add('is-busy'); body.setAttribute('aria-busy','true');}
    var payload={attributes:{_ob_gift:attr}}; if(key){payload.updates={}; payload.updates[key]=0;}
    fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
    .then(function(r){if(!r.ok)throw new Error('gift '+r.status);})
    .then(function(){
      if(live)live.textContent=key?'Free Magnesium+ removed.':'Adding your free Magnesium+.';
      refresh();
      var h=body&&body.closest('.obd')?$('#obc-title'):$('.obcp-h1'); if(h)h.focus();
    })
    .catch(function(){location.reload();})
    .then(function(){if(body){body.classList.remove('is-busy'); body.removeAttribute('aria-busy');}});
  }
  d.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ob-gift-decline],[data-ob-gift-accept]');
    if(!b)return;
    e.preventDefault();
    if(b.hasAttribute('data-ob-gift-decline'))giftChoice(b,'declined',b.getAttribute('data-key'));
    else giftChoice(b,'',null);
  });

  function openCart(opener){if(!cartDlg){location.href='/cart';return;} openDialog(cartDlg,opener,$('#obc-title')); refresh();}
  d.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-ob-cart-open]');
    if(!a||!cartDlg||onCartPage())return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1)return;
    e.preventDefault(); openCart(a);
  });
  d.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ob-qty]');
    if(!b)return;
    e.preventDefault();
    var body=b.closest('[data-ob-cart-body]'), fk=b.getAttribute('data-fk'), removing=b.getAttribute('data-q')==='0';
    if(body){body.classList.add('is-busy'); body.setAttribute('aria-busy','true');}
    fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:parseInt(b.getAttribute('data-line'),10),quantity:parseInt(b.getAttribute('data-q'),10),sections:sectionIds().join(','),sections_url:location.pathname})})
    .then(function(r){if(!r.ok)throw new Error('change '+r.status); return r.json();})
    .then(function(c){
      apply(c.sections); setCount(c.item_count);
      if(live)live.textContent=(removing?'Item removed. ':'Cart updated. ')+(c.item_count?('Subtotal '+money(c.total_price)+'.'):'Your cart is empty.');
      var t=body&&!removing&&fk&&$('[data-fk="'+fk+'"]',body);
      if(t&&!t.disabled)t.focus(); else {var h=body&&body.closest('.obd')?$('#obc-title'):$('.obcp-h1'); if(h)h.focus();}
      try{d.dispatchEvent(new CustomEvent('ob:cart-updated',{detail:c}));}catch(x){}
    })
    .catch(function(){location.reload();})
    .then(function(){if(body){body.classList.remove('is-busy'); body.removeAttribute('aria-busy');}});
  });
  d.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ob-add]');
    if(!b)return;
    e.preventDefault();
    var body=b.closest('[data-ob-cart-body]'), name=b.getAttribute('data-ob-add-name')||'Item', src=b.getAttribute('data-ob-add-src')||'cart-free-ship';
    if(body){body.classList.add('is-busy'); body.setAttribute('aria-busy','true');}
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(b.getAttribute('data-ob-add'),10),quantity:1,properties:{_ob_source:src}}],sections:sectionIds().join(','),sections_url:location.pathname})})
    .then(function(r){if(!r.ok)throw new Error('add '+r.status); return r.json();})
    .then(function(res){
      apply(res.sections);
      return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
        setCount(c.item_count);
        if(live)live.textContent=name+' added. Subtotal '+money(c.total_price)+(c.total_price>=4000?'. Your order ships free.':'.');
        var h=body&&body.closest('.obd')?$('#obc-title'):$('.obcp-h1'); if(h)h.focus();
        try{d.dispatchEvent(new CustomEvent('ob:cart-updated',{detail:c}));}catch(x){}
      });
    })
    .catch(function(){location.reload();})
    .then(function(){if(body){body.classList.remove('is-busy'); body.removeAttribute('aria-busy');}});
  });
  /* Tier upgrade in the cart (3 Reasons offer): add the next tier, then remove the current one */
  d.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ob-swap-to]');
    if(!b)return;
    e.preventDefault();
    var body=b.closest('[data-ob-cart-body]'), key=b.getAttribute('data-ob-swap-key'), to=parseInt(b.getAttribute('data-ob-swap-to'),10), from=b.getAttribute('data-ob-swap-from'), n=b.getAttribute('data-ob-swap-n');
    if(body){body.classList.add('is-busy'); body.setAttribute('aria-busy','true');}
    var H={'Content-Type':'application/json','Accept':'application/json'};
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:H,body:JSON.stringify({items:[{id:to,quantity:1,properties:{_ob_funnel:'3r-v2',_ob_pack:String(n),_ob_upgrade:'from-'+from}}]})})
    .then(function(r){if(!r.ok)throw new Error('add '+r.status); return r.json();})
    .then(function(){return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:H,body:JSON.stringify({id:key,quantity:0,sections:sectionIds().join(','),sections_url:location.pathname})});})
    .then(function(r){if(!r.ok)throw new Error('change '+r.status); return r.json();})
    .then(function(c){
      apply(c.sections); setCount(c.item_count);
      if(live)live.textContent='Upgraded to '+n+' Roll-Ons. Subtotal '+money(c.total_price)+'. Your order ships free.';
      var h=body&&body.closest('.obd')?$('#obc-title'):$('.obcp-h1'); if(h)h.focus();
      try{d.dispatchEvent(new CustomEvent('ob:cart-updated',{detail:c}));}catch(x){}
    })
    .catch(function(){location.reload();})
    .then(function(){if(body){body.classList.remove('is-busy'); body.removeAttribute('aria-busy');}});
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
  /* Cart page: make sure the gift line matches the cart on first load (PDP add-to-cart redirects here) */
  if($('[data-ob-cart-page]'))giftSync();
  window.OBCart={open:openCart,refresh:refresh};
})();
